import { fork } from "@redux-saga/core/effects";
import { statsigSaga } from "@stores/auth/statsigSaga";
import auth from "./auth";
import preference from "./preference";

function* mainSaga() {
  yield fork(auth.saga);
  yield fork(statsigSaga);
  yield fork(preference.saga);
}

export default mainSaga;
